import { orderMethods } from '../../constants/checkout'; 

export const STORAGE_PRESET_STATUS_KEY = 'checkoutPresetStatus';
export const STORAGE_PRESET_DATA_KEY = 'checkoutPresetData';

export const presetStatus = {
    IN_PROGRESS: 'in-progress',
    FAILED: 'failed',
    COMPLETED: 'completed',
    CANCELED: 'canceled',
};

export const screenType = {
    ORDER_TYPE: 'order_type',
    
    PICKUP: 'pickup',
    
    DELIVERY_ADDRESS: 'delivery_address',
    UBER_DELIVERY_ADDRESS: 'uber_delivery_address',
    DOORDASH_DELIVERY_ADDRESS: 'doordash_delivery_address',
    
    SCHEDULE_TIME: 'schedule_time',
    DELIVERY_SCHEDULE_TIME: 'delivery_schedule_time',
    DOORDASH_DELIVERY_SCHEDULE_TIME: 'doordash_delivery_schedule_time',
    UBER_DELIVERY_SCHEDULE_TIME: 'uber_delivery_schedule_time',
};

export const orderTypeScreen = {
    [orderMethods.pickup]: screenType.SCHEDULE_TIME,
    [orderMethods.delivery]: screenType.DELIVERY_ADDRESS,
    [orderMethods.doordash_delivery]: screenType.DOORDASH_DELIVERY_ADDRESS,
    [orderMethods.uber_delivery]: screenType.UBER_DELIVERY_ADDRESS,
};

export const screenTypeRouter = {
    [screenType.PICKUP]: {
        next: screenType.SCHEDULE_TIME,
        prev: screenType.ORDER_TYPE,
    },
    
    [screenType.DELIVERY_ADDRESS]: {
        next: screenType.DELIVERY_SCHEDULE_TIME,
        prev: screenType.ORDER_TYPE,
    },
    [screenType.UBER_DELIVERY_ADDRESS]: {
        next: screenType.UBER_DELIVERY_SCHEDULE_TIME,
        prev: screenType.ORDER_TYPE,
    },
    [screenType.DOORDASH_DELIVERY_ADDRESS]: {
        next: screenType.DOORDASH_DELIVERY_SCHEDULE_TIME,
        prev: screenType.ORDER_TYPE,
    },
    
    [screenType.SCHEDULE_TIME]: {
        next: null,
        prev: screenType.ORDER_TYPE,
    },
    [screenType.DELIVERY_SCHEDULE_TIME]: {
        next: null,
        prev: screenType.DELIVERY_ADDRESS,
    },
    [screenType.UBER_DELIVERY_SCHEDULE_TIME]: {
        next: null,
        prev: screenType.UBER_DELIVERY_ADDRESS,
    },
    [screenType.DOORDASH_DELIVERY_SCHEDULE_TIME]: {
        next: null,
        prev: screenType.DOORDASH_DELIVERY_ADDRESS,
    },
    // [screenType.]: {
    //     next: screenType.,
    //     prev: screenType.,
    // },
};

export const orderTypes = [
    {
        id: orderMethods.pickup,
        name: 'Pickup',
        description: '',
    },
    {
        id: orderMethods.delivery,
        name: 'Delivery',
        description: 'Delivery provided by Vendor',
    },
    {
        id: orderMethods.doordash_delivery,
        name: 'Delivery',
        description: 'Delivery provided by DoorDash',
    },
    {
        id: orderMethods.uber_delivery,
        name: 'Delivery',
        description: 'Delivery provided by Uber',
    },
];
